// Lightweight translation catalog for InterviewGenieAI pages.
// Keys are the original English UI strings after whitespace normalization.
// Add more keys here anytime; the runtime safely falls back to English when a key is missing.

export const supportedLanguages = [
  { code: 'en', label: 'English', nativeLabel: 'English', shortLabel: 'EN', dir: 'ltr' },
  { code: 'ar', label: 'Arabic', nativeLabel: 'العربية', shortLabel: 'Ar', dir: 'rtl' },
  { code: 'fr', label: 'French', nativeLabel: 'Français', shortLabel: 'Fr', dir: 'ltr' },
];

export const defaultLanguage = 'en';

const fr = {
  'Dashboard': 'Tableau de bord',
  'Sessions Planner': 'Planificateur de sessions',
  'AI Interview': 'Entretien IA',
  'AI Chat': 'Chat IA',
  'Questions AI': 'Questions IA',
  'Library': 'Bibliothèque',
  'Analytics': 'Analytique',
  'Analytics & Insights': 'Analytique et insights',
  'Resume AI': 'CV IA',
  'ATS Optimization': 'Optimisation ATS',
  'PDF Editor': 'Éditeur PDF',
  'Questions Bank': 'Banque de questions',
  'Question Bank': 'Banque de questions',
  'JobMatch AI': 'JobMatch IA',
  'Settings': 'Paramètres',
  'Help': 'Aide',
  'Navigation': 'Navigation',
  'More': 'Plus',
  'Logout': 'Déconnexion',
  'Log out': 'Se déconnecter',
  'User Profile': 'Profil utilisateur',
  'Billing & Subscriptions': 'Facturation et abonnements',
  'Report an issue': 'Signaler un problème',
  'Bugs, UX/UI feedback, performance, ...': 'Bugs, retours UX/UI, performance, ...',
  'Professional Assistant': 'Assistant professionnel',
  'Upgrade': 'Mettre à niveau',
  'Upgrade required': 'Mise à niveau requise',
  'requires an upgrade': 'nécessite une mise à niveau',
  'is locked on the Free plan.': 'est verrouillé dans le plan gratuit.',
  'Free': 'Gratuit',
  'Starter': 'Débutant',
  'Professional': 'Professionnel',
  'Executive': 'Exécutif',
  'Good start': 'Bon départ',
  'Most popular': 'Le plus populaire',
  'Teams': 'Équipes',
  'Limited interviews': 'Entretiens limités',
  'Basic feedback': 'Feedback de base',
  'Community support': 'Support communautaire',
  'More interviews': 'Plus d’entretiens',
  'Better analytics': 'Meilleure analytique',
  'Email support': 'Support par email',
  'Unlimited interviews': 'Entretiens illimités',
  'Advanced scorecards': 'Fiches de score avancées',
  'Priority support': 'Support prioritaire',
  'Team seats': 'Places équipe',
  'Admin analytics': 'Analytique admin',
  'SLA support': 'Support SLA',
  'Manage': 'Gérer',
  'View': 'Voir',
  'Usage': 'Utilisation',
  'Remaining': 'Restant',
  'Level': 'Niveau',
  'Rank': 'Rang',
  'Leaderboard': 'Classement',
  'Interview Setup': 'Configuration de l’entretien',
  'Live Session': 'Session en direct',
  'Live Interview': 'Entretien en direct',
  'Results': 'Résultats',
  'Results & Feedback': 'Résultats et feedback',
  'Practice Library': 'Bibliothèque d’entraînement',
  'Phone Interview': 'Entretien téléphonique',
  'Reports and issues': 'Rapports et problèmes',
  'Start Free Interview': 'Commencer l’entretien gratuit',
  'Start Free Trial': 'Démarrer l’essai gratuit',
  'Sign in': 'Se connecter',
  'Sign In': 'Se connecter',
  'Log In': 'Connexion',
  'Login': 'Connexion',
  'Start Free': 'Commencer gratuitement',
  'Create account': 'Créer un compte',
  'Create Account': 'Créer un compte',
  'Sign up': 'S’inscrire',
  'Sign Up': 'S’inscrire',
  'Email Address': 'Adresse email',
  'email': 'email',
  'Email': 'Email',
  'Password': 'Mot de passe',
  'password': 'mot de passe',
  'Confirm Password': 'Confirmer le mot de passe',
  'Remember me': 'Se souvenir de moi',
  'Forgot password?': 'Mot de passe oublié ?',
  'Forgot Password': 'Mot de passe oublié',
  'Back to Login': 'Retour à la connexion',
  'Reset Password': 'Réinitialiser le mot de passe',
  'Send Reset Link': 'Envoyer le lien de réinitialisation',
  'Full Name': 'Nom complet',
  'Enter your full name': 'Entrez votre nom complet',
  'Continue': 'Continuer',
  'Back': 'Retour',
  'Next': 'Suivant',
  'Previous': 'Précédent',
  'Prev': 'Préc.',
  'Cancel': 'Annuler',
  'Close': 'Fermer',
  'Save': 'Enregistrer',
  'Saved': 'Enregistré',
  'Delete': 'Supprimer',
  'Download': 'Télécharger',
  'Export': 'Exporter',
  'Copy': 'Copier',
  'Clear': 'Effacer',
  'Clear search': 'Effacer la recherche',
  'Search': 'Rechercher',
  'Submit': 'Envoyer',
  'submit': 'envoyer',
  'Submit Answer': 'Envoyer la réponse',
  'Retry': 'Réessayer',
  'Reload': 'Recharger',
  'Reset': 'Réinitialiser',
  'Done': 'Terminé',
  'Skip': 'Ignorer',
  'Open': 'Ouvrir',
  'New': 'Nouveau',
  'Add': 'Ajouter',
  'Optional': 'Optionnel',
  'Selected': 'Sélectionné',
  'All': 'Tous',
  'All Roles': 'Tous les rôles',
  'All statuses': 'Tous les statuts',
  'Status': 'Statut',
  'Details': 'Détails',
  'Description': 'Description',
  'Title': 'Titre',
  'Content': 'Contenu',
  'Message': 'Message',
  'message': 'message',
  'Contact': 'Contact',
  'Support': 'Support',
  'Connection Error': 'Erreur de connexion',
  'Pricing': 'Tarifs',
  'Features': 'Fonctionnalités',
  'Product': 'Produit',
  'Privacy Policy': 'Politique de confidentialité',
  'Terms of Service': 'Conditions d’utilisation',
  '© 2025 InterviewGenieAI. All rights reserved.': '© 2025 InterviewGenieAI. Tous droits réservés.',
  'The most advanced AI interview preparation platform': 'La plateforme de préparation aux entretiens IA la plus avancée',
  'Interview': 'Entretien',
  'Interview Type': 'Type d’entretien',
  'Questions': 'Questions',
  'Question': 'Question',
  'Answer': 'Réponse',
  'Notes': 'Notes',
  'Score': 'Score',
  'Score:': 'Score :',
  'Overall Score': 'Score global',
  'Strengths': 'Points forts',
  'Areas to Improve': 'Axes d’amélioration',
  'Improvements': 'Améliorations',
  'Recommendations': 'Recommandations',
  'Performance': 'Performance',
  'performance': 'performance',
  'Review': 'Revue',
  'Response Time': 'Temps de réponse',
  'Confidence': 'Confiance',
  'Clarity': 'Clarté',
  'Communication': 'Communication',
  'Professionalism': 'Professionnalisme',
  'Relevance': 'Pertinence',
  'Tone': 'Ton',
  'Pacing': 'Rythme',
  'Filler Words': 'Mots de remplissage',
  'Filler words': 'Mots de remplissage',
  'Eye Contact': 'Contact visuel',
  'Body Language': 'Langage corporel',
  'Engagement': 'Engagement',
  'End Interview': 'Terminer l’entretien',
  'Start Interview': 'Commencer l’entretien',
  'AI Interviewer': 'Intervieweur IA',
  'AI Personality': 'Personnalité IA',
  'Role Targeting': 'Ciblage du rôle',
  'Target Role': 'Rôle cible',
  'Role': 'Rôle',
  'Company': 'Entreprise',
  'Industry': 'Secteur',
  'Difficulty': 'Difficulté',
  'Difficulty Level': 'Niveau de difficulté',
  'Duration': 'Durée',
  'Format': 'Format',
  'Behavioral': 'Comportemental',
  'behavioral': 'comportemental',
  'Technical': 'Technique',
  'technical': 'technique',
  'System Design': 'Conception système',
  'system design': 'conception système',
  'Practice': 'Entraînement',
  'practice': 'entraînement',
  'Resources': 'Ressources',
  'Learning Path': 'Parcours d’apprentissage',
  'Quick Tips': 'Conseils rapides',
  'Video Tutorial': 'Tutoriel vidéo',
  'Calendar': 'Calendrier',
  'Sessions': 'Sessions',
  'Achievements': 'Réussites',
  'Progress': 'Progression',
  'Completed': 'Terminé',
  'In Progress': 'En cours',
  'In progress': 'En cours',
  'in_progress': 'en_cours',
  'Overdue': 'En retard',
  'Blocked': 'Bloqué',
  'backlog': 'backlog',
  'planned': 'planifié',
  'done': 'terminé',
  'Coming Soon': 'Bientôt disponible',
  'Beginner': 'Débutant',
  'Intermediate': 'Intermédiaire',
  'Advanced': 'Avancé',
  'Medium': 'Moyen',
  'Private': 'Privé',
  'General': 'Général',
  'Overview': 'Vue d’ensemble',
  'Insights': 'Insights',
  'Activity': 'Activité',
  'Filters': 'Filtres',
  'Models': 'Modèles',
  'Upload': 'Importer',
  'Choose Template': 'Choisir un modèle',
  'Choose Path': 'Choisir un parcours',
  'Create a report': 'Créer un rapport',
  'New report': 'Nouveau rapport',
  'My reports': 'Mes rapports',
  'Resolved': 'Résolu',
  'Dismiss': 'Ignorer',
  'Warning': 'Avertissement',
  'warning': 'avertissement',
  'Info': 'Info',
  'Total': 'Total',
  'Avg score': 'Score moyen',
  'Rating': 'Note',
  'Target': 'Cible',
  'Language': 'Langue',
  'English': 'Anglais',
  'French': 'Français',
  'Arabic': 'Arabe',
  'United States': 'États-Unis',
  'United Kingdom': 'Royaume-Uni',
  'France': 'France',
  'Saudi Arabia': 'Arabie saoudite',
  'American English': 'Anglais américain',
  'British English': 'Anglais britannique',
  'Software Engineer': 'Ingénieur logiciel',
  'Full Stack Developer': 'Développeur full stack',
  'Frontend Developer': 'Développeur frontend',
  'Backend Developer': 'Développeur backend',
  'Product Manager': 'Product manager',
  'Engineering Manager': 'Engineering manager',
  'DevOps Engineer': 'Ingénieur DevOps',
  'ML Engineer': 'Ingénieur ML',
  'Data Analyst': 'Analyste de données',
  'Data Scientist': 'Data scientist',
  'QA Engineer': 'Ingénieur QA',
  'UX Designer': 'Designer UX',
  'Marketing Manager': 'Responsable marketing',
  'Security Engineer': 'Ingénieur sécurité',
  'Cloud Engineer': 'Ingénieur cloud',
  'Mobile Engineer': 'Ingénieur mobile',
  'Site Reliability Engineer': 'Ingénieur fiabilité site',
  'Embedded Engineer': 'Ingénieur embarqué',
  'Technology': 'Technologie',
  'Healthcare': 'Santé',
  'Consulting': 'Conseil',
  'Finance & Banking': 'Finance et banque',
  'Retail & E-commerce': 'Retail et e-commerce',
  'Marketing & Advertising': 'Marketing et publicité',
  'Non-Profit': 'Association',
};

const ar = {
  'Dashboard': 'لوحة التحكم',
  'Sessions Planner': 'مخطط الجلسات',
  'AI Interview': 'مقابلة بالذكاء الاصطناعي',
  'AI Chat': 'دردشة الذكاء الاصطناعي',
  'Questions AI': 'أسئلة الذكاء الاصطناعي',
  'Library': 'المكتبة',
  'Analytics': 'التحليلات',
  'Analytics & Insights': 'التحليلات والرؤى',
  'Resume AI': 'السيرة الذاتية بالذكاء الاصطناعي',
  'ATS Optimization': 'تحسين ATS',
  'PDF Editor': 'محرر PDF',
  'Questions Bank': 'بنك الأسئلة',
  'Question Bank': 'بنك الأسئلة',
  'JobMatch AI': 'مطابقة الوظائف بالذكاء الاصطناعي',
  'Settings': 'الإعدادات',
  'Help': 'المساعدة',
  'Navigation': 'التنقل',
  'More': 'المزيد',
  'Logout': 'تسجيل الخروج',
  'Log out': 'تسجيل الخروج',
  'User Profile': 'ملف المستخدم',
  'Billing & Subscriptions': 'الفوترة والاشتراكات',
  'Report an issue': 'الإبلاغ عن مشكلة',
  'Bugs, UX/UI feedback, performance, ...': 'أخطاء، ملاحظات UX/UI، الأداء، ...',
  'Professional Assistant': 'مساعد احترافي',
  'Upgrade': 'ترقية',
  'Upgrade required': 'الترقية مطلوبة',
  'requires an upgrade': 'يتطلب ترقية',
  'is locked on the Free plan.': 'مقفل في الخطة المجانية.',
  'Free': 'مجاني',
  'Starter': 'البداية',
  'Professional': 'احترافي',
  'Executive': 'تنفيذي',
  'Good start': 'بداية جيدة',
  'Most popular': 'الأكثر شيوعًا',
  'Teams': 'الفرق',
  'Limited interviews': 'مقابلات محدودة',
  'Basic feedback': 'ملاحظات أساسية',
  'Community support': 'دعم المجتمع',
  'More interviews': 'مقابلات أكثر',
  'Better analytics': 'تحليلات أفضل',
  'Email support': 'دعم عبر البريد',
  'Unlimited interviews': 'مقابلات غير محدودة',
  'Advanced scorecards': 'بطاقات تقييم متقدمة',
  'Priority support': 'دعم بأولوية',
  'Team seats': 'مقاعد للفريق',
  'Admin analytics': 'تحليلات الإدارة',
  'SLA support': 'دعم SLA',
  'Manage': 'إدارة',
  'View': 'عرض',
  'Usage': 'الاستخدام',
  'Remaining': 'المتبقي',
  'Level': 'المستوى',
  'Rank': 'الترتيب',
  'Leaderboard': 'لوحة الترتيب',
  'Interview Setup': 'إعداد المقابلة',
  'Live Session': 'جلسة مباشرة',
  'Live Interview': 'مقابلة مباشرة',
  'Results': 'النتائج',
  'Results & Feedback': 'النتائج والملاحظات',
  'Practice Library': 'مكتبة التدريب',
  'Phone Interview': 'مقابلة هاتفية',
  'Reports and issues': 'التقارير والمشاكل',
  'Start Free Interview': 'ابدأ مقابلة مجانية',
  'Start Free Trial': 'ابدأ تجربة مجانية',
  'Sign in': 'تسجيل الدخول',
  'Sign In': 'تسجيل الدخول',
  'Log In': 'تسجيل الدخول',
  'Login': 'تسجيل الدخول',
  'Start Free': 'ابدأ مجاناً',
  'Create account': 'إنشاء حساب',
  'Create Account': 'إنشاء حساب',
  'Sign up': 'إنشاء حساب',
  'Sign Up': 'إنشاء حساب',
  'Email Address': 'عنوان البريد الإلكتروني',
  'email': 'البريد الإلكتروني',
  'Email': 'البريد الإلكتروني',
  'Password': 'كلمة المرور',
  'password': 'كلمة المرور',
  'Confirm Password': 'تأكيد كلمة المرور',
  'Remember me': 'تذكرني',
  'Forgot password?': 'نسيت كلمة المرور؟',
  'Forgot Password': 'نسيت كلمة المرور',
  'Back to Login': 'العودة إلى تسجيل الدخول',
  'Reset Password': 'إعادة تعيين كلمة المرور',
  'Send Reset Link': 'إرسال رابط إعادة التعيين',
  'Full Name': 'الاسم الكامل',
  'Enter your full name': 'أدخل اسمك الكامل',
  'Continue': 'متابعة',
  'Back': 'رجوع',
  'Next': 'التالي',
  'Previous': 'السابق',
  'Prev': 'السابق',
  'Cancel': 'إلغاء',
  'Close': 'إغلاق',
  'Save': 'حفظ',
  'Saved': 'تم الحفظ',
  'Delete': 'حذف',
  'Download': 'تحميل',
  'Export': 'تصدير',
  'Copy': 'نسخ',
  'Clear': 'مسح',
  'Clear search': 'مسح البحث',
  'Search': 'بحث',
  'Submit': 'إرسال',
  'submit': 'إرسال',
  'Submit Answer': 'إرسال الإجابة',
  'Retry': 'إعادة المحاولة',
  'Reload': 'إعادة التحميل',
  'Reset': 'إعادة تعيين',
  'Done': 'تم',
  'Skip': 'تخطي',
  'Open': 'فتح',
  'New': 'جديد',
  'Add': 'إضافة',
  'Optional': 'اختياري',
  'Selected': 'محدد',
  'All': 'الكل',
  'All Roles': 'كل الأدوار',
  'All statuses': 'كل الحالات',
  'Status': 'الحالة',
  'Details': 'التفاصيل',
  'Description': 'الوصف',
  'Title': 'العنوان',
  'Content': 'المحتوى',
  'Message': 'الرسالة',
  'message': 'الرسالة',
  'Contact': 'تواصل',
  'Support': 'الدعم',
  'Connection Error': 'خطأ في الاتصال',
  'Pricing': 'الأسعار',
  'Features': 'المميزات',
  'Product': 'المنتج',
  'Privacy Policy': 'سياسة الخصوصية',
  'Terms of Service': 'شروط الخدمة',
  '© 2025 InterviewGenieAI. All rights reserved.': '© 2025 InterviewGenieAI. جميع الحقوق محفوظة.',
  'The most advanced AI interview preparation platform': 'أقوى منصة للتحضير للمقابلات بالذكاء الاصطناعي',
  'Interview': 'مقابلة',
  'Interview Type': 'نوع المقابلة',
  'Questions': 'الأسئلة',
  'Question': 'السؤال',
  'Answer': 'الإجابة',
  'Notes': 'ملاحظات',
  'Score': 'النتيجة',
  'Score:': 'النتيجة:',
  'Overall Score': 'النتيجة العامة',
  'Strengths': 'نقاط القوة',
  'Areas to Improve': 'مجالات التحسين',
  'Improvements': 'تحسينات',
  'Recommendations': 'توصيات',
  'Performance': 'الأداء',
  'performance': 'الأداء',
  'Review': 'مراجعة',
  'Response Time': 'وقت الاستجابة',
  'Confidence': 'الثقة',
  'Clarity': 'الوضوح',
  'Communication': 'التواصل',
  'Professionalism': 'الاحترافية',
  'Relevance': 'الملاءمة',
  'Tone': 'النبرة',
  'Pacing': 'الإيقاع',
  'Filler Words': 'كلمات الحشو',
  'Filler words': 'كلمات الحشو',
  'Eye Contact': 'التواصل البصري',
  'Body Language': 'لغة الجسد',
  'Engagement': 'التفاعل',
  'End Interview': 'إنهاء المقابلة',
  'Start Interview': 'بدء المقابلة',
  'AI Interviewer': 'المحاور الذكي',
  'AI Personality': 'شخصية الذكاء الاصطناعي',
  'Role Targeting': 'تحديد الدور',
  'Target Role': 'الدور المستهدف',
  'Role': 'الدور',
  'Company': 'الشركة',
  'Industry': 'المجال',
  'Difficulty': 'الصعوبة',
  'Difficulty Level': 'مستوى الصعوبة',
  'Duration': 'المدة',
  'Format': 'الصيغة',
  'Behavioral': 'سلوكي',
  'behavioral': 'سلوكي',
  'Technical': 'تقني',
  'technical': 'تقني',
  'System Design': 'تصميم الأنظمة',
  'system design': 'تصميم الأنظمة',
  'Practice': 'تدريب',
  'practice': 'تدريب',
  'Resources': 'الموارد',
  'Learning Path': 'مسار التعلم',
  'Quick Tips': 'نصائح سريعة',
  'Video Tutorial': 'شرح فيديو',
  'Calendar': 'التقويم',
  'Sessions': 'الجلسات',
  'Achievements': 'الإنجازات',
  'Progress': 'التقدم',
  'Completed': 'مكتمل',
  'In Progress': 'قيد التنفيذ',
  'In progress': 'قيد التنفيذ',
  'in_progress': 'قيد_التنفيذ',
  'Overdue': 'متأخر',
  'Blocked': 'محظور',
  'backlog': 'في الانتظار',
  'planned': 'مخطط',
  'done': 'تم',
  'Coming Soon': 'قريبًا',
  'Beginner': 'مبتدئ',
  'Intermediate': 'متوسط',
  'Advanced': 'متقدم',
  'Medium': 'متوسط',
  'Private': 'خاص',
  'General': 'عام',
  'Overview': 'نظرة عامة',
  'Insights': 'رؤى',
  'Activity': 'النشاط',
  'Filters': 'الفلاتر',
  'Models': 'النماذج',
  'Upload': 'رفع',
  'Choose Template': 'اختر قالبًا',
  'Choose Path': 'اختر المسار',
  'Create a report': 'إنشاء تقرير',
  'New report': 'تقرير جديد',
  'My reports': 'تقاريري',
  'Resolved': 'تم الحل',
  'Dismiss': 'تجاهل',
  'Warning': 'تحذير',
  'warning': 'تحذير',
  'Info': 'معلومة',
  'Total': 'الإجمالي',
  'Avg score': 'متوسط النتيجة',
  'Rating': 'التقييم',
  'Target': 'الهدف',
  'Language': 'اللغة',
  'English': 'الإنجليزية',
  'French': 'الفرنسية',
  'Arabic': 'العربية',
  'United States': 'الولايات المتحدة',
  'United Kingdom': 'المملكة المتحدة',
  'France': 'فرنسا',
  'Saudi Arabia': 'السعودية',
  'American English': 'الإنجليزية الأمريكية',
  'British English': 'الإنجليزية البريطانية',
  'Software Engineer': 'مهندس برمجيات',
  'Full Stack Developer': 'مطور Full Stack',
  'Frontend Developer': 'مطور واجهات أمامية',
  'Backend Developer': 'مطور Backend',
  'Product Manager': 'مدير منتج',
  'Engineering Manager': 'مدير هندسة',
  'DevOps Engineer': 'مهندس DevOps',
  'ML Engineer': 'مهندس تعلم آلي',
  'Data Analyst': 'محلل بيانات',
  'Data Scientist': 'عالم بيانات',
  'QA Engineer': 'مهندس ضمان الجودة',
  'UX Designer': 'مصمم UX',
  'Marketing Manager': 'مدير تسويق',
  'Security Engineer': 'مهندس أمن',
  'Cloud Engineer': 'مهندس سحابة',
  'Mobile Engineer': 'مطور تطبيقات موبايل',
  'Site Reliability Engineer': 'مهندس موثوقية الموقع',
  'Embedded Engineer': 'مهندس أنظمة مدمجة',
  'Technology': 'التكنولوجيا',
  'Healthcare': 'الصحة',
  'Consulting': 'الاستشارات',
  'Finance & Banking': 'المالية والبنوك',
  'Retail & E-commerce': 'التجزئة والتجارة الإلكترونية',
  'Marketing & Advertising': 'التسويق والإعلانات',
  'Non-Profit': 'غير ربحي',
};


// Landing page complete i18n patch
Object.assign(fr, {
  "Pass your next interview.": "Réussissez votre prochain entretien.",
  "Train with AI until you pass.": "Entraînez-vous avec l’IA jusqu’à réussir.",
  "Most candidates fail because they do not know what to say, how to structure answers, or where they are losing points. Practice realistic AI interviews, get instant feedback, and improve every answer before the real one.": "La plupart des candidats échouent parce qu’ils ne savent pas quoi dire, comment structurer leurs réponses, ni où ils perdent des points. Entraînez-vous avec des entretiens IA réalistes, recevez un feedback instantané et améliorez chaque réponse avant le vrai entretien.",
  "InterviewGenieAI — Train with AI Until You Pass Real Interviews": "InterviewGenieAI — Entraînez-vous avec l’IA jusqu’à réussir vos vrais entretiens",
  "Practice realistic AI interviews, get instant feedback, and start free with 2 AI interviews every month. No credit card required.": "Entraînez-vous avec des entretiens IA réalistes, recevez un feedback instantané et commencez gratuitement avec 2 entretiens IA chaque mois. Aucune carte bancaire requise.",
  "Free account": "Compte gratuit",
  "Sign up in seconds": "Inscription en quelques secondes",
  "Included every month": "Inclus chaque mois",
  "No credit card": "Aucune carte bancaire",
  "Start free. Upgrade only when ready": "Commencez gratuitement. Passez à l’offre supérieure seulement quand vous êtes prêt.",
  "InterviewGenie AI": "InterviewGenie AI",
  "Ready to analyze your interview skills": "Prêt à analyser vos compétences d’entretien",
  "Choose Your Target Role:": "Choisissez votre rôle cible :",
  "Demo Question:": "Question de démonstration :",
  "Start Demo Challenge": "Commencer le défi démo",
  "Listen": "Écouter",
  "Respond": "Répondre",
  "Listening to your response...": "Écoute de votre réponse...",
  "Your Response:": "Votre réponse :",
  "Recording...": "Enregistrement...",
  "Get Started": "Commencer",
  "Submit & Analyze Response": "Envoyer et analyser la réponse",
  "AI Analysis in Progress": "Analyse IA en cours",
  "Our AI is meticulously evaluating every aspect of your response...": "Notre IA évalue soigneusement chaque aspect de votre réponse...",
  "• Processing speech patterns • Analyzing tone • Evaluating structure •": "• Traitement des schémas de parole • Analyse du ton • Évaluation de la structure •",
  "Great Job!": "Excellent travail !",
  "You're leveling up already": "Vous progressez déjà",
  "+15 Interview XP": "+15 XP entretien",
  "Your Strengths & One Thing to Improve": "Vos points forts et un axe d’amélioration",
  "✅ Strong Areas:": "✅ Points forts :",
  "• Clear communication style": "• Communication claire",
  "• Good eye contact": "• Bon contact visuel",
  "• Professional tone": "• Ton professionnel",
  "🎯 Focus Area:": "🎯 Axe de concentration :",
  "• Reduce filler words (\"um\", \"like\")": "• Réduire les mots de remplissage (« euh », « genre »)",
  "• Use more role-specific keywords": "• Utiliser davantage de mots-clés liés au poste",
  "• Strengthen opening statement": "• Renforcer l’introduction",
  "Try Again": "Réessayer",
  "Create Free Account": "Créer un compte gratuit",
  "Create a free account to save your progress and use 2 AI interviews every month": "Créez un compte gratuit pour sauvegarder votre progression et utiliser 2 entretiens IA chaque mois",
  "What makes InterviewGenieAI different from normal mock interview tools?": "Qu’est-ce qui différencie InterviewGenieAI des outils classiques de simulation d’entretien ?",
  "InterviewGenieAI does not just give you random questions. It simulates realistic AI interviews, analyzes your answers, and tells you exactly what to improve: structure, clarity, confidence, filler words, relevance, and impact.": "InterviewGenieAI ne se contente pas de proposer des questions aléatoires. Il simule des entretiens IA réalistes, analyse vos réponses et vous indique exactement quoi améliorer : structure, clarté, confiance, mots de remplissage, pertinence et impact.",
  "Can I practice for my exact role or industry?": "Puis-je m’entraîner pour mon rôle ou mon secteur exact ?",
  "Yes. You can train for different roles, industries, seniority levels, and interview formats including behavioral, technical, phone, chat, and panel-style interviews.": "Oui. Vous pouvez vous entraîner pour différents rôles, secteurs, niveaux d’expérience et formats d’entretien, y compris comportemental, technique, téléphonique, chat et panel.",
  "What does the free plan include?": "Que comprend l’offre gratuite ?",
  "The free plan includes 2 AI interviews every month, basic feedback, and access to the core practice experience. No credit card required.": "L’offre gratuite inclut 2 entretiens IA chaque mois, un feedback de base et l’accès à l’expérience principale d’entraînement. Aucune carte bancaire requise.",
  "Will the AI help me improve weak answers?": "L’IA m’aidera-t-elle à améliorer mes réponses faibles ?",
  "Yes. The platform highlights weak areas and gives clear improvement suggestions, including how to make answers more structured, specific, confident, and aligned with the target role.": "Oui. La plateforme met en évidence les points faibles et fournit des suggestions claires pour rendre les réponses plus structurées, précises, confiantes et alignées avec le rôle cible.",
  "Does it support technical interviews?": "Prend-il en charge les entretiens techniques ?",
  "Yes. InterviewGenieAI supports technical practice flows for developers and other roles, including role-specific questions and feedback focused on explanation quality, problem-solving, and communication.": "Oui. InterviewGenieAI prend en charge les parcours d’entraînement technique pour les développeurs et d’autres rôles, avec des questions spécifiques au poste et un feedback sur la qualité d’explication, la résolution de problèmes et la communication.",
  "Can schools or training centers use InterviewGenieAI?": "Les écoles ou centres de formation peuvent-ils utiliser InterviewGenieAI ?",
  "Yes. Training centers, schools, and career programs can use InterviewGenieAI to help learners practice interviews, track improvement, and prepare for job placement.": "Oui. Les centres de formation, écoles et programmes carrière peuvent utiliser InterviewGenieAI pour aider les apprenants à s’entraîner, suivre leurs progrès et se préparer au placement professionnel.",
  "Is my interview data private?": "Mes données d’entretien sont-elles privées ?",
  "Interview preparation can be personal, so the product should clearly communicate privacy, account control, and data handling. Keep your privacy policy visible and let users know how their data is used.": "La préparation à l’entretien peut être personnelle, donc le produit doit clairement communiquer la confidentialité, le contrôle du compte et la gestion des données. Gardez votre politique de confidentialité visible et expliquez comment les données sont utilisées.",
  "Can I cancel anytime?": "Puis-je annuler à tout moment ?",
  "Yes. Paid users should be able to manage or cancel their plan from the billing area, while keeping access until the end of the active billing period.": "Oui. Les utilisateurs payants doivent pouvoir gérer ou annuler leur offre depuis l’espace de facturation, tout en gardant l’accès jusqu’à la fin de la période active.",
  "FAQ": "FAQ",
  "How it works": "Comment ça marche",
  "Watch demo": "Voir la démo",
  "AI Interviewer": "Intervieweur IA",
  "Question 1 of 5": "Question 1 sur 5",
  "Can you tell me about a challenging project you worked on and how you contributed to its success?": "Pouvez-vous me parler d’un projet difficile sur lequel vous avez travaillé et expliquer comment vous avez contribué à sa réussite ?",
  "Feedback:": "Feedback :",
  "Clear": "Clair",
  "Good": "Bon",
  "Strong": "Fort",
  "Minimal": "Minimal",
  "Coming Soon": "Bientôt disponible",
  "Video Analysis": "Analyse vidéo",
  "Review your performance": "Analysez votre performance",
  "Your browser does not support the video tag.": "Votre navigateur ne prend pas en charge la balise vidéo.",
  "Analyzing...": "Analyse en cours...",
  "Eye Contact": "Contact visuel",
  "Eye Contact: 65%": "Contact visuel : 65%",
  "Confidence: 78%": "Confiance : 78%",
  "Performance Analysis": "Analyse de performance",
  "Confidence Level": "Niveau de confiance",
  "Pace & Rhythm": "Rythme et cadence",
  "Body Language": "Langage corporel",
  "Key Observations:": "Observations clés :",
  "Good posture and hand gestures when explaining complex topics": "Bonne posture et gestes adaptés lors de l’explication de sujets complexes",
  "Try to maintain more consistent eye contact with the camera": "Essayez de maintenir un contact visuel plus constant avec la caméra",
  "Appropriate speaking pace with good vocal variety": "Débit de parole adapté avec une bonne variété vocale",
  "Avoid looking down too frequently when referring to notes": "Évitez de regarder trop souvent vers le bas en consultant vos notes",
  "Overall Performance Score:": "Score global de performance :",
  "Phone Interview Simulation": "Simulation d’entretien téléphonique",
  "Practice phone screening rounds": "Entraînez-vous aux présélections téléphoniques",
  "TechCorp Inc. Recruiter": "Recruteur TechCorp Inc.",
  "Connected • 12:45": "Connecté • 12:45",
  "Connection: Excellent": "Connexion : excellente",
  "Audio: Clear": "Audio : clair",
  "Call Analysis": "Analyse de l’appel",
  "Pacing": "Rythme",
  "Response Time": "Temps de réponse",
  "Professionalism": "Professionnalisme",
  "Conversation Highlights:": "Extraits de conversation :",
  "Interviewer:": "Intervieweur :",
  "You:": "Vous :",
  "\"Can you walk me through your experience with React and Node.js?\"": "« Pouvez-vous me présenter votre expérience avec React et Node.js ? »",
  "\"I've worked with React for about 3 years, building several SPAs and recently working with Next.js for SSR applications.\"": "« J’ai travaillé avec React pendant environ 3 ans, en construisant plusieurs SPA et récemment avec Next.js pour des applications SSR. »",
  "\"How do you handle state management in large applications?\"": "« Comment gérez-vous l’état dans les grandes applications ? »",
  "Filler Words Detected:": "Mots de remplissage détectés :",
  "um (5)": "euh (5)",
  "like (3)": "genre (3)",
  "you know (2)": "vous savez (2)",
  "actually (2)": "en fait (2)",
  "Call Performance Score:": "Score de performance de l’appel :",
  "Realistic": "Réaliste",
  "AI interviews for voice, chat, behavioral, technical, and panel practice": "Entretiens IA pour la voix, le chat, le comportemental, le technique et les panels",
  "Instant": "Instantané",
  "Feedback on structure, clarity, confidence, filler words, and relevance": "Feedback sur la structure, la clarté, la confiance, les mots de remplissage et la pertinence",
  "Repeat": "Répéter",
  "Improve answer by answer until your interview score becomes consistent": "Améliorez réponse par réponse jusqu’à obtenir un score d’entretien régulier",
  "Real result example": "Exemple de résultat réel",
  "Stop guessing why you failed. See exactly what to improve.": "Arrêtez de deviner pourquoi vous avez échoué. Voyez exactement quoi améliorer.",
  "InterviewGenieAI turns every practice answer into a clear coaching report, so users know what to fix before facing a recruiter or hiring manager.": "InterviewGenieAI transforme chaque réponse d’entraînement en rapport de coaching clair, afin que les utilisateurs sachent quoi corriger avant de rencontrer un recruteur ou un manager.",
  "Before InterviewGenieAI": "Avant InterviewGenieAI",
  "Weak answer with no STAR structure": "Réponse faible sans structure STAR",
  "Too vague, no metrics, no clear impact": "Trop vague, sans métriques ni impact clair",
  "Confidence score drops under pressure": "Le score de confiance baisse sous pression",
  "After AI coaching": "Après le coaching IA",
  "Structured answer using STAR method": "Réponse structurée avec la méthode STAR",
  "Clear business impact and stronger keywords": "Impact business clair et mots-clés plus forts",
  "Final score:": "Score final :",
  "— interview ready": "— prêt pour l’entretien",
  "Inspired by interviews at leading tech companies": "Inspiré des entretiens dans les grandes entreprises tech",
  "Platform Capabilities": "Capacités de la plateforme",
  "Engineered for": "Conçu pour",
  "Interview Mastery": "Maîtriser les entretiens",
  "Every feature meticulously designed to transform your interview performance with surgical precision": "Chaque fonctionnalité est conçue avec précision pour transformer votre performance d’entretien",
  "View on larger screen": "Voir sur un écran plus grand",
  "Enhanced visualization available on desktop": "Visualisation améliorée disponible sur ordinateur",
  "Switch to larger screen for detailed view": "Passez à un écran plus grand pour une vue détaillée",
  "Advanced Capability": "Capacité avancée",
  "Premium Feature": "Fonctionnalité premium",
  "Advanced Feature": "Fonctionnalité avancée",
  "Premium Visualization": "Visualisation premium",
  "Switch to desktop for detailed interface preview and enhanced visuals": "Passez sur ordinateur pour un aperçu détaillé de l’interface et des visuels améliorés",
  "Available in full detail on desktop. Includes enhanced visuals, interactive elements, and comprehensive interface previews.": "Disponible en détail complet sur ordinateur. Inclut des visuels améliorés, des éléments interactifs et des aperçus complets de l’interface.",
  "Ready to experience elite-level interview preparation?": "Prêt à découvrir une préparation d’entretien de niveau élite ?",
  "Watch Platform Tour": "Voir la visite de la plateforme",
  "For Every Candidate": "Pour chaque candidat",
  "Built for Every": "Conçu pour chaque",
  "Career Journey": "Parcours professionnel",
  "From students and first-time job seekers to senior professionals and executives, our AI adapts to every career stage with precise, personalized interview preparation.": "Des étudiants et primo-demandeurs d’emploi aux professionnels seniors et cadres, notre IA s’adapte à chaque étape de carrière avec une préparation précise et personnalisée.",
  "Your personalized interview journey starts here": "Votre parcours d’entretien personnalisé commence ici",
  "Create Your Profile": "Créer votre profil",
  "See Personalization in Action": "Voir la personnalisation en action",
  "Four steps to become": "Quatre étapes pour devenir",
  "interview ready": "prêt pour l’entretien",
  "Choose your role, start an AI interview, get instant feedback, then repeat until your answers are clear, confident, and job-ready.": "Choisissez votre rôle, lancez un entretien IA, recevez un feedback instantané, puis recommencez jusqu’à ce que vos réponses soient claires, confiantes et prêtes pour l’emploi.",
  "AI Analysis Engine": "Moteur d’analyse IA",
  "Active Monitoring System": "Système de suivi actif",
  "Real-time Processing": "Traitement en temps réel",
  "Deep Performance Analytics": "Analytique avancée de performance",
  "View Details →": "Voir les détails →",
  "Experience AI-Powered": "Découvrez un coaching",
  "Interview Coaching": "d’entretien alimenté par l’IA",
  "Try our interactive demo and see how our AI transforms your interview skills": "Essayez notre démo interactive et voyez comment notre IA transforme vos compétences d’entretien",
  "Trusted by candidates from": "Utilisé par des candidats de",
  "Frequently Asked": "Questions",
  "Everything you need to know about the product": "Tout ce que vous devez savoir sur le produit",
  "Success Stories": "Histoires de réussite",
  "Candidates who": "Candidats qui",
  "train smarter": "s’entraînent plus intelligemment",
  "Show the transformation: nervous answers become structured, confident responses users can repeat in real interviews": "Montrez la transformation : des réponses nerveuses deviennent des réponses structurées et confiantes que les utilisateurs peuvent répéter en entretien réel",
  "The Minds Behind the Magic": "Les esprits derrière la magie",
  "Meet Our": "Rencontrez notre",
  "Expert Team": "équipe d’experts",
  "A passionate team of AI researchers, career coaches, and engineering experts dedicated to revolutionizing interview preparation": "Une équipe passionnée de chercheurs IA, coachs carrière et experts ingénierie dédiée à révolutionner la préparation aux entretiens",
  "Years Combined Experience": "Années d’expérience cumulée",
  "Our team brings decades of expertise from top tech companies and institutions": "Notre équipe apporte des décennies d’expertise issues des meilleures entreprises tech et institutions",
  "Successful AI Projects": "Projets IA réussis",
  "Proven track record in developing cutting-edge artificial intelligence solutions": "Expérience prouvée dans le développement de solutions d’intelligence artificielle de pointe",
  "Career Placements": "Placements professionnels",
  "Collectively helped thousands secure positions at leading global companies": "A aidé collectivement des milliers de personnes à obtenir des postes dans de grandes entreprises mondiales",
  "Ready to Pass Your Next Interview?": "Prêt à réussir votre prochain entretien ?",
  "Start practicing now, get instant feedback, and build the confidence to answer like a prepared candidate": "Commencez à vous entraîner maintenant, recevez un feedback instantané et gagnez la confiance nécessaire pour répondre comme un candidat préparé",
  "No credit card required • Free plan includes 2 AI interviews/month • Upgrade when you need more practice": "Aucune carte bancaire requise • L’offre gratuite inclut 2 entretiens IA/mois • Passez à l’offre supérieure quand vous avez besoin de plus de pratique",
  "How It Works": "Comment ça marche",
  "Resources": "Ressources",
  "Blog": "Blog",
  "Tutorials": "Tutoriels",
  "Documentation": "Documentation",
  "Company": "Entreprise",
  "About": "À propos",
  "Careers": "Carrières",
  "Legal": "Mentions légales",
  "Terms": "Conditions",
  "Privacy": "Confidentialité",
  "Cookies": "Cookies"
});

Object.assign(ar, {
  "Pass your next interview.": "اجتز مقابلتك القادمة.",
  "Train with AI until you pass.": "تدرّب مع الذكاء الاصطناعي حتى تنجح.",
  "Most candidates fail because they do not know what to say, how to structure answers, or where they are losing points. Practice realistic AI interviews, get instant feedback, and improve every answer before the real one.": "يفشل معظم المرشحين لأنهم لا يعرفون ماذا يقولون، وكيف ينظمون إجاباتهم، أو أين يخسرون النقاط. تدرّب على مقابلات ذكاء اصطناعي واقعية، واحصل على ملاحظات فورية، وحسّن كل إجابة قبل المقابلة الحقيقية.",
  "InterviewGenieAI — Train with AI Until You Pass Real Interviews": "InterviewGenieAI — تدرّب بالذكاء الاصطناعي حتى تنجح في المقابلات الحقيقية",
  "Practice realistic AI interviews, get instant feedback, and start free with 2 AI interviews every month. No credit card required.": "تدرّب على مقابلات ذكاء اصطناعي واقعية، واحصل على ملاحظات فورية، وابدأ مجانًا مع مقابلتين بالذكاء الاصطناعي كل شهر. لا حاجة لبطاقة بنكية.",
  "Free account": "حساب مجاني",
  "Sign up in seconds": "سجّل في ثوانٍ",
  "Included every month": "مشمولة كل شهر",
  "No credit card": "بدون بطاقة بنكية",
  "Start free. Upgrade only when ready": "ابدأ مجانًا. قم بالترقية فقط عندما تكون جاهزًا.",
  "InterviewGenie AI": "InterviewGenie AI",
  "Ready to analyze your interview skills": "جاهز لتحليل مهاراتك في المقابلات",
  "Choose Your Target Role:": "اختر الدور المستهدف:",
  "Demo Question:": "سؤال تجريبي:",
  "Start Demo Challenge": "ابدأ تحدي العرض التجريبي",
  "Listen": "استمع",
  "Respond": "أجب",
  "Listening to your response...": "يستمع إلى إجابتك...",
  "Your Response:": "إجابتك:",
  "Recording...": "جاري التسجيل...",
  "Get Started": "ابدأ الآن",
  "Submit & Analyze Response": "إرسال وتحليل الإجابة",
  "AI Analysis in Progress": "تحليل الذكاء الاصطناعي قيد التقدم",
  "Our AI is meticulously evaluating every aspect of your response...": "يقوم الذكاء الاصطناعي بتقييم كل جانب من إجابتك بدقة...",
  "• Processing speech patterns • Analyzing tone • Evaluating structure •": "• معالجة أنماط الكلام • تحليل النبرة • تقييم البنية •",
  "Great Job!": "عمل رائع!",
  "You're leveling up already": "أنت تتحسن بالفعل",
  "+15 Interview XP": "+15 نقطة خبرة مقابلة",
  "Your Strengths & One Thing to Improve": "نقاط قوتك وشيء واحد للتحسين",
  "✅ Strong Areas:": "✅ نقاط قوية:",
  "• Clear communication style": "• أسلوب تواصل واضح",
  "• Good eye contact": "• تواصل بصري جيد",
  "• Professional tone": "• نبرة احترافية",
  "🎯 Focus Area:": "🎯 مجال التركيز:",
  "• Reduce filler words (\"um\", \"like\")": "• قلّل كلمات الحشو مثل «أمم» و«يعني»",
  "• Use more role-specific keywords": "• استخدم كلمات مفتاحية مرتبطة بالدور أكثر",
  "• Strengthen opening statement": "• قوِّ المقدمة الافتتاحية",
  "Try Again": "حاول مرة أخرى",
  "Create Free Account": "أنشئ حسابًا مجانيًا",
  "Create a free account to save your progress and use 2 AI interviews every month": "أنشئ حسابًا مجانيًا لحفظ تقدمك واستخدام مقابلتين بالذكاء الاصطناعي كل شهر",
  "What makes InterviewGenieAI different from normal mock interview tools?": "ما الذي يجعل InterviewGenieAI مختلفًا عن أدوات المقابلات التجريبية العادية؟",
  "InterviewGenieAI does not just give you random questions. It simulates realistic AI interviews, analyzes your answers, and tells you exactly what to improve: structure, clarity, confidence, filler words, relevance, and impact.": "لا يقدّم InterviewGenieAI أسئلة عشوائية فقط. إنه يحاكي مقابلات ذكاء اصطناعي واقعية، يحلل إجاباتك، ويخبرك بالضبط بما يجب تحسينه: البنية، الوضوح، الثقة، كلمات الحشو، الصلة، والتأثير.",
  "Can I practice for my exact role or industry?": "هل يمكنني التدرّب على دوري أو مجالي بالتحديد؟",
  "Yes. You can train for different roles, industries, seniority levels, and interview formats including behavioral, technical, phone, chat, and panel-style interviews.": "نعم. يمكنك التدرّب على أدوار ومجالات ومستويات خبرة مختلفة، وأنواع مقابلات تشمل السلوكية، التقنية، الهاتفية، الدردشة، ومقابلات اللجنة.",
  "What does the free plan include?": "ماذا تتضمن الخطة المجانية؟",
  "The free plan includes 2 AI interviews every month, basic feedback, and access to the core practice experience. No credit card required.": "تتضمن الخطة المجانية مقابلتين بالذكاء الاصطناعي كل شهر، وملاحظات أساسية، والوصول إلى تجربة التدريب الأساسية. لا حاجة لبطاقة بنكية.",
  "Will the AI help me improve weak answers?": "هل سيساعدني الذكاء الاصطناعي على تحسين الإجابات الضعيفة؟",
  "Yes. The platform highlights weak areas and gives clear improvement suggestions, including how to make answers more structured, specific, confident, and aligned with the target role.": "نعم. تبرز المنصة نقاط الضعف وتقدم اقتراحات واضحة للتحسين، بما في ذلك جعل الإجابات أكثر تنظيمًا وتحديدًا وثقة وتوافقًا مع الدور المستهدف.",
  "Does it support technical interviews?": "هل يدعم المقابلات التقنية؟",
  "Yes. InterviewGenieAI supports technical practice flows for developers and other roles, including role-specific questions and feedback focused on explanation quality, problem-solving, and communication.": "نعم. يدعم InterviewGenieAI مسارات تدريب تقنية للمطورين وأدوار أخرى، مع أسئلة مرتبطة بالدور وملاحظات تركز على جودة الشرح وحل المشكلات والتواصل.",
  "Can schools or training centers use InterviewGenieAI?": "هل يمكن للمدارس أو مراكز التدريب استخدام InterviewGenieAI؟",
  "Yes. Training centers, schools, and career programs can use InterviewGenieAI to help learners practice interviews, track improvement, and prepare for job placement.": "نعم. يمكن لمراكز التدريب والمدارس وبرامج التوظيف استخدام InterviewGenieAI لمساعدة المتعلمين على التدريب على المقابلات، وتتبع التحسن، والاستعداد للتوظيف.",
  "Is my interview data private?": "هل بيانات مقابلاتي خاصة؟",
  "Interview preparation can be personal, so the product should clearly communicate privacy, account control, and data handling. Keep your privacy policy visible and let users know how their data is used.": "قد تكون التحضيرات للمقابلة شخصية، لذلك يجب أن يوضح المنتج الخصوصية والتحكم في الحساب وطريقة التعامل مع البيانات. أبقِ سياسة الخصوصية واضحة وأخبر المستخدمين كيف تُستخدم بياناتهم.",
  "Can I cancel anytime?": "هل يمكنني الإلغاء في أي وقت؟",
  "Yes. Paid users should be able to manage or cancel their plan from the billing area, while keeping access until the end of the active billing period.": "نعم. يجب أن يتمكن المستخدمون المدفوعون من إدارة أو إلغاء خطتهم من قسم الفوترة مع الاحتفاظ بالوصول حتى نهاية فترة الدفع الحالية.",
  "FAQ": "الأسئلة الشائعة",
  "How it works": "كيف يعمل",
  "Watch demo": "شاهد العرض",
  "AI Interviewer": "مُقابل بالذكاء الاصطناعي",
  "Question 1 of 5": "السؤال 1 من 5",
  "Can you tell me about a challenging project you worked on and how you contributed to its success?": "هل يمكنك أن تخبرني عن مشروع صعب عملت عليه وكيف ساهمت في نجاحه؟",
  "Feedback:": "ملاحظات:",
  "Clear": "واضح",
  "Good": "جيد",
  "Strong": "قوي",
  "Minimal": "قليل جدًا",
  "Coming Soon": "قريبًا",
  "Video Analysis": "تحليل الفيديو",
  "Review your performance": "راجع أداءك",
  "Your browser does not support the video tag.": "متصفحك لا يدعم وسم الفيديو.",
  "Analyzing...": "جاري التحليل...",
  "Eye Contact": "التواصل البصري",
  "Eye Contact: 65%": "التواصل البصري: 65%",
  "Confidence: 78%": "الثقة: 78%",
  "Performance Analysis": "تحليل الأداء",
  "Confidence Level": "مستوى الثقة",
  "Pace & Rhythm": "السرعة والإيقاع",
  "Body Language": "لغة الجسد",
  "Key Observations:": "ملاحظات رئيسية:",
  "Good posture and hand gestures when explaining complex topics": "وضعية جيدة وحركات يد مناسبة عند شرح مواضيع معقدة",
  "Try to maintain more consistent eye contact with the camera": "حاول الحفاظ على تواصل بصري أكثر ثباتًا مع الكاميرا",
  "Appropriate speaking pace with good vocal variety": "سرعة كلام مناسبة مع تنوع صوتي جيد",
  "Avoid looking down too frequently when referring to notes": "تجنب النظر للأسفل كثيرًا عند الرجوع إلى الملاحظات",
  "Overall Performance Score:": "درجة الأداء الإجمالية:",
  "Phone Interview Simulation": "محاكاة مقابلة هاتفية",
  "Practice phone screening rounds": "تدرّب على مراحل الفرز الهاتفي",
  "TechCorp Inc. Recruiter": "مسؤول توظيف TechCorp Inc.",
  "Connected • 12:45": "متصل • 12:45",
  "Connection: Excellent": "الاتصال: ممتاز",
  "Audio: Clear": "الصوت: واضح",
  "Call Analysis": "تحليل المكالمة",
  "Pacing": "الإيقاع",
  "Response Time": "وقت الاستجابة",
  "Professionalism": "الاحترافية",
  "Conversation Highlights:": "أبرز نقاط المحادثة:",
  "Interviewer:": "المقابِل:",
  "You:": "أنت:",
  "\"Can you walk me through your experience with React and Node.js?\"": "«هل يمكنك شرح خبرتك مع React وNode.js؟»",
  "\"I've worked with React for about 3 years, building several SPAs and recently working with Next.js for SSR applications.\"": "«عملت مع React حوالي 3 سنوات، وبنيت عدة تطبيقات SPA، ومؤخرًا استخدمت Next.js لتطبيقات SSR.»",
  "\"How do you handle state management in large applications?\"": "«كيف تتعامل مع إدارة الحالة في التطبيقات الكبيرة؟»",
  "Filler Words Detected:": "كلمات الحشو المكتشفة:",
  "um (5)": "أمم (5)",
  "like (3)": "يعني (3)",
  "you know (2)": "كما تعلم (2)",
  "actually (2)": "في الواقع (2)",
  "Call Performance Score:": "درجة أداء المكالمة:",
  "Realistic": "واقعي",
  "AI interviews for voice, chat, behavioral, technical, and panel practice": "مقابلات ذكاء اصطناعي للتدريب الصوتي والدردشة والسلوكي والتقني واللجان",
  "Instant": "فوري",
  "Feedback on structure, clarity, confidence, filler words, and relevance": "ملاحظات حول البنية والوضوح والثقة وكلمات الحشو والملاءمة",
  "Repeat": "كرّر",
  "Improve answer by answer until your interview score becomes consistent": "حسّن إجابة تلو الأخرى حتى تصبح نتيجتك في المقابلات ثابتة",
  "Real result example": "مثال نتيجة حقيقية",
  "Stop guessing why you failed. See exactly what to improve.": "توقف عن التخمين لماذا فشلت. اعرف بالضبط ما يجب تحسينه.",
  "InterviewGenieAI turns every practice answer into a clear coaching report, so users know what to fix before facing a recruiter or hiring manager.": "يحوّل InterviewGenieAI كل إجابة تدريبية إلى تقرير تدريب واضح، حتى يعرف المستخدمون ما يجب إصلاحه قبل مقابلة مسؤول التوظيف أو المدير.",
  "Before InterviewGenieAI": "قبل InterviewGenieAI",
  "Weak answer with no STAR structure": "إجابة ضعيفة بدون بنية STAR",
  "Too vague, no metrics, no clear impact": "غامضة جدًا، بدون أرقام أو تأثير واضح",
  "Confidence score drops under pressure": "درجة الثقة تنخفض تحت الضغط",
  "After AI coaching": "بعد تدريب الذكاء الاصطناعي",
  "Structured answer using STAR method": "إجابة منظمة بطريقة STAR",
  "Clear business impact and stronger keywords": "تأثير عملي واضح وكلمات مفتاحية أقوى",
  "Final score:": "النتيجة النهائية:",
  "— interview ready": "— جاهز للمقابلة",
  "Inspired by interviews at leading tech companies": "مستوحى من مقابلات شركات التقنية الكبرى",
  "Platform Capabilities": "قدرات المنصة",
  "Engineered for": "مصمم من أجل",
  "Interview Mastery": "إتقان المقابلات",
  "Every feature meticulously designed to transform your interview performance with surgical precision": "كل ميزة مصممة بعناية لتحويل أدائك في المقابلات بدقة عالية",
  "View on larger screen": "اعرض على شاشة أكبر",
  "Enhanced visualization available on desktop": "تصور محسّن متاح على سطح المكتب",
  "Switch to larger screen for detailed view": "انتقل إلى شاشة أكبر لعرض تفصيلي",
  "Advanced Capability": "قدرة متقدمة",
  "Premium Feature": "ميزة مميزة",
  "Advanced Feature": "ميزة متقدمة",
  "Premium Visualization": "تصور مميز",
  "Switch to desktop for detailed interface preview and enhanced visuals": "انتقل إلى سطح المكتب لمعاينة واجهة مفصلة ومرئيات محسّنة",
  "Available in full detail on desktop. Includes enhanced visuals, interactive elements, and comprehensive interface previews.": "متاح بتفاصيل كاملة على سطح المكتب. يشمل مرئيات محسّنة وعناصر تفاعلية ومعاينات شاملة للواجهة.",
  "Ready to experience elite-level interview preparation?": "هل أنت جاهز لتجربة تحضير مقابلات بمستوى احترافي؟",
  "Watch Platform Tour": "شاهد جولة المنصة",
  "For Every Candidate": "لكل مرشح",
  "Built for Every": "مصمم لكل",
  "Career Journey": "مسار مهني",
  "From students and first-time job seekers to senior professionals and executives, our AI adapts to every career stage with precise, personalized interview preparation.": "من الطلاب والباحثين عن العمل لأول مرة إلى المحترفين الكبار والمديرين التنفيذيين، يتكيف الذكاء الاصطناعي مع كل مرحلة مهنية بتحضير دقيق وشخصي.",
  "Your personalized interview journey starts here": "تبدأ رحلتك الشخصية في المقابلات هنا",
  "Create Your Profile": "أنشئ ملفك الشخصي",
  "See Personalization in Action": "شاهد التخصيص عمليًا",
  "Four steps to become": "أربع خطوات لتصبح",
  "interview ready": "جاهزًا للمقابلة",
  "Choose your role, start an AI interview, get instant feedback, then repeat until your answers are clear, confident, and job-ready.": "اختر دورك، ابدأ مقابلة بالذكاء الاصطناعي، احصل على ملاحظات فورية، ثم كرّر حتى تصبح إجاباتك واضحة وواثقة وجاهزة للعمل.",
  "AI Analysis Engine": "محرك تحليل الذكاء الاصطناعي",
  "Active Monitoring System": "نظام مراقبة نشط",
  "Real-time Processing": "معالجة في الوقت الحقيقي",
  "Deep Performance Analytics": "تحليلات أداء عميقة",
  "View Details →": "عرض التفاصيل →",
  "Experience AI-Powered": "جرّب تدريبًا مدعومًا",
  "Interview Coaching": "بالذكاء الاصطناعي للمقابلات",
  "Try our interactive demo and see how our AI transforms your interview skills": "جرّب العرض التفاعلي وشاهد كيف يحوّل الذكاء الاصطناعي مهاراتك في المقابلات",
  "Trusted by candidates from": "موثوق به من مرشحين من",
  "Frequently Asked": "الأسئلة",
  "Everything you need to know about the product": "كل ما تحتاج معرفته عن المنتج",
  "Success Stories": "قصص النجاح",
  "Candidates who": "مرشحون",
  "train smarter": "يتدربون بذكاء أكبر",
  "Show the transformation: nervous answers become structured, confident responses users can repeat in real interviews": "اعرض التحول: تتحول الإجابات المتوترة إلى إجابات منظمة وواثقة يمكن للمستخدمين تكرارها في المقابلات الحقيقية",
  "The Minds Behind the Magic": "العقول وراء السحر",
  "Meet Our": "تعرّف على",
  "Expert Team": "فريق الخبراء",
  "A passionate team of AI researchers, career coaches, and engineering experts dedicated to revolutionizing interview preparation": "فريق شغوف من باحثي الذكاء الاصطناعي ومدربي المسار المهني وخبراء الهندسة مكرّس لتغيير طريقة التحضير للمقابلات",
  "Years Combined Experience": "سنوات خبرة مجتمعة",
  "Our team brings decades of expertise from top tech companies and institutions": "يجلب فريقنا عقودًا من الخبرة من أفضل شركات التقنية والمؤسسات",
  "Successful AI Projects": "مشاريع ذكاء اصطناعي ناجحة",
  "Proven track record in developing cutting-edge artificial intelligence solutions": "سجل مثبت في تطوير حلول ذكاء اصطناعي متقدمة",
  "Career Placements": "توظيفات مهنية",
  "Collectively helped thousands secure positions at leading global companies": "ساعدنا بشكل جماعي آلاف الأشخاص على الحصول على وظائف في شركات عالمية كبرى",
  "Ready to Pass Your Next Interview?": "هل أنت جاهز لاجتياز مقابلتك القادمة؟",
  "Start practicing now, get instant feedback, and build the confidence to answer like a prepared candidate": "ابدأ التدريب الآن، واحصل على ملاحظات فورية، وابنِ الثقة للإجابة مثل مرشح مستعد",
  "No credit card required • Free plan includes 2 AI interviews/month • Upgrade when you need more practice": "لا حاجة لبطاقة بنكية • الخطة المجانية تشمل مقابلتين بالذكاء الاصطناعي شهريًا • قم بالترقية عندما تحتاج إلى تدريب أكثر",
  "How It Works": "كيف يعمل",
  "Resources": "الموارد",
  "Blog": "المدونة",
  "Tutorials": "الدروس",
  "Documentation": "التوثيق",
  "Company": "الشركة",
  "About": "حول",
  "Careers": "الوظائف",
  "Legal": "قانوني",
  "Terms": "الشروط",
  "Privacy": "الخصوصية",
  "Cookies": "ملفات تعريف الارتباط"
});

// Landing page metric and SEO additions
Object.assign(fr, {
  "Structure": "Structure",
  "Structure:": "Structure :",
  "Clarity:": "Clarté :",
  "Confidence:": "Confiance :",
  "Filler Words:": "Mots de remplissage :",
  "Demo": "Démo",
  "InterviewGenieAI: Train with AI Until You Pass Real Interviews": "InterviewGenieAI : entraînez-vous avec l’IA jusqu’à réussir les vrais entretiens"
});

Object.assign(ar, {
  "Structure": "البنية",
  "Structure:": "البنية:",
  "Clarity:": "الوضوح:",
  "Confidence:": "الثقة:",
  "Filler Words:": "كلمات الحشو:",
  "Demo": "عرض",
  "InterviewGenieAI: Train with AI Until You Pass Real Interviews": "InterviewGenieAI: تدرّب بالذكاء الاصطناعي حتى تنجح في المقابلات الحقيقية"
});

export const translations = { en: {}, fr, ar };

export function normalizeI18nText(value = '') {
  return String(value).replace(/\s+/g, ' ').trim();
}

export function getLanguageMeta(lang) {
  return supportedLanguages.find((item) => item.code === lang) || supportedLanguages[0];
}
